module.exports = __webpack_public_path__ + "images/4-big.png";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/img/paypal/4-big.png
 ** module id = 575
 ** module chunks = 0
 **/